import { create } from 'zustand';
import type { DialogListWidthState, DialogListWidthActions } from './types';

/** Сохраняет ширину при переключении между приложением и внешними каналами */
export const useDialogListWidth = create<DialogListWidthState & DialogListWidthActions>((set) => ({
    width: null,

    setWidth: (width) => set({ width }),
}));
